import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import HeaderAll from "../../../HeaderAll";

function HeaderTransfer({ info,data }) {
  const styf = { fontWeight: "1200" };

  return (
    <Grid item container
      justifyContent="center"
      style={{
        fontWeight: "bold", fontFamily: "Amiri-Regular",
      }}>
      <HeaderAll Report={true} found={info} />

      <Grid item container style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}>
        <Grid item xs={12} style={{
          fontFamily: "Amiri-Regular", border: "solid 2px", paddingTop: "0.5rem", paddingBottom: "0.5rem",
          borderRadius: "5px", textAlign: "center",
        }}
        >
          <div style={styf}>
            {data.title}
          </div>
        </Grid>
      </Grid>
      <Grid item container style={{
        fontFamily: "Amiri-Regular", padding: "0.3rem", border: "solid 2px",
        borderRadius: "5px", direction: "rtl",
      }}
      >
        <Grid item xs={12} container>
          <Grid item xs={2} style={{ textAlign: "right" }}>
            {data.kind == 5 ? <> {" الصنف"}/{" "} {data.curr}</> : <> {"رقم الأمر"}/{" "} {data.transNo}</>}
          </Grid>
          <Grid item xs={2} style={{ textAlign: "right" }}>
            {"الفرع"} /{" "} {data.branch}
          </Grid>
          {data.kind == 3 ?
            (
              <>
                <Grid item xs={4} style={{ textAlign: "right" }}>
                  {"المخزن المحول منه"} /{" "}   {data.safeFrom}
                </Grid>
                <Grid item xs={3} style={{ textAlign: "right" }}>
                  {"المخزن المحول الية"} /{" "}   {data.safeTo}
                </Grid> </>
            )
            : (
              <Grid item xs={4} style={{ textAlign: "right" }}>
                {"المخزن  "} /{" "}   {data.safe}
              </Grid>
            )
          }
          {data.kind == 5 ?
            (
              <>
                <Grid item xs={3} style={{ textAlign: "right" }}>
                  {"من تاريخ"} /{" "}   {data.fDate}
                </Grid>
                <Grid item xs={3} style={{ textAlign: "right" }}>
                  {"الى تاريخ"} /{" "}   {data.tDate}
                </Grid>
              </>
            )
            : (
              <Grid item xs={3} style={{ textAlign: "right" }}>
                {"التاريخ"} /{" "}   {data.date}
              </Grid>
            )
          }
          <Grid item xs={3} style={{ textAlign: "right" }}>
            {"تاريخ الطباعة"} /{" "}   {data.nDate}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
export default HeaderTransfer;